// employees/EmployeeContext.js
import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {getDirectoryApi} from "api/services/companyDirectory"
import {exportEmployeeApi} from "api/services/employee"
import { useSearchParams } from 'react-router-dom';
import useEmployeeFilter from "../hooks/filterHook"
import {  useNavigate } from "react-router-dom";
import {format} from "date-fns"
import { filterHandler } from 'utils/common';
import { useMediaQuery } from "react-responsive";



// Create the Employee context
export const EmployeeContext = createContext();

// Custom hook for accessing Employee context easily
export const useEmployee = () => {
  return useContext(EmployeeContext);
};

// EmployeeProvider component to wrap around components needing access to employee data
export const EmployeeProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const navigate = useNavigate()

  // Employee state (could be an array of employees, single employee, etc.)
  const [loading, setLoading] = useState(false);    
  const [exportLoading, setExportLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);

  
  const [employeeData, setEmployeeData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange} = useEmployeeFilter(pageSettings , setPageSettings);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params
        
})

const setEmployeeParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...filter_params
    }
    setSearchParams(params)
}
// handleInputChange = (value, key)=>{
//     setPageSettings({
//         ...pageSettings,
//         page: 1,
//         filters
//       })
//       handleSearchInput(value, key))
// }


    const getEmployeeList = () => {
        setLoading(true)
        setFilterLoading(true)

        // let _filters = [...filters].filter(item=> item.value)
        // const filter_params = _filters.reduce((acc, item) => {
        //     acc[item.key] = item.value;
        //     return acc;
        //   }, {});
        let filter_params = getFilterParams()

        if(filter_params?.employment_date_after){
            filter_params.employment_date_after = format(new Date(filter_params.employment_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.employment_date_before){
            filter_params.employment_date_before = format(new Date(filter_params.employment_date_before), "yyyy-MM-dd")
        }


          
        getDirectoryApi({
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          ...filter_params
    
        }).then(response=>{
          console.log(response.data.results)
          if(view=="grid" && pageSettings?.page!==1){
            setEmployeeData([...employeeData,...response.data.results]);

          }else{
            setEmployeeData(response.data.results);

          }

          // setEmployeeData(response.data.results);
          setPageSettings({
            ...pageSettings,
            total: response.data.count
          })
    
          setLoading(false)
          setFilterLoading(false)
          setShowFilterDrawer(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{

    getEmployeeList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])

  useEffect(()=>{
    setEmployeeParams(pageSettings)
  },[pageSettings])

  const handleApplyFilter = () => {
    // setFilterLoading(true)
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })
    // getEmployeeList()


  }

  const handleGridChange = (page, size) =>{
    // console.log(page, size, "pageSettings")
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
    // setSearchParams({
    //     size,
    //     page,
    // })
  }
  const handleChange = (pagination, filters, sorter) => {
    console.log(pagination, filters, sorter, "pagination, filters, sorter")
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    // setSearchParams({
    //     size: pageData?.pageSize,
    //     page: pageData?.page,
    //     sort_by: pageData?.sortBy || "",
    //     sort_type: pageData?.sortType || ""
    // })
    setPageSettings(pageData)
  };

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }


  const handleEmployeeDetailPage = (id, index) => {
    navigate(`/company-directory/${id}`)
    setSelectedPage(index)
  }

  const handleExport = () => {
    let filter_params = getFilterParams()

    if(filter_params?.employment_date_after){
      filter_params.employment_date_after = format(new Date(filter_params.employment_date_after), "yyyy-MM-dd")
    }
    if(filter_params?.employment_date_before){
      filter_params.employment_date_before = format(new Date(filter_params.employment_date_before), "yyyy-MM-dd")
    }

    setExportLoading(true)
      
    exportEmployeeApi({
      sort_by: pageSettings?.sortBy,
      sort_type: pageSettings?.sortType,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      ...filter_params
    }, { 
      responseType: 'blob'
    }).then(response => {
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      
      const filename = 'employee_export.xlsx';
      link.setAttribute('download', filename);
      
      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
      
      setExportLoading(false);
    }).catch(e => {
      console.error('Export failed:', e);
      setExportLoading(false);
    });
  }



  // Calculate applied filter count
  const appliedFilterCount = useMemo(() => {
    return filters.filter(item => item.value && item.key !== "search").length;
  }, [filters]);

  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    employeeData, setEmployeeData,
    loading, setLoading,
    employeeData, setEmployeeData,
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    handleGridChange,
    handleChange,
    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleEmployeeDetailPage,
    handleDateChange,
    handleExport,
    exportLoading, setExportLoading,
    appliedFilterCount
    
  }), [employeeData , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, exportLoading, appliedFilterCount]);

  return (
    <EmployeeContext.Provider value={value}>
      {children}
    </EmployeeContext.Provider>
  );
};